export const ProjectsListPage = () => import(/* webpackChunkName: "projects-list-page" */ "./pages/projects-list-page");
export const ProjectDetailsPage = () => import(/* webpackChunkName: "project-details-page" */ "./pages/project-details-page");
export { registerModals } from "./components";
